import { NativeSyntheticEvent, Platform, TextInputKeyPressEventData } from 'react-native'

/**
 * On a computer, Enter in a message field sends and Shift+Enter adds a line.
 * On a phone or tablet (app or browser) Enter keeps adding a line, since the
 * touch keyboard has no handy Shift+Enter.
 */
export const isEnterToSend = (e: NativeSyntheticEvent<TextInputKeyPressEventData>): boolean => {
  if (Platform.OS !== 'web') return false

  // On the web the native event is the browser's keydown event.
  const key = e.nativeEvent as unknown as KeyboardEvent
  if (key.key !== 'Enter' || key.shiftKey || key.ctrlKey || key.altKey || key.metaKey) return false

  // Enter that validates an accent or a character being composed is not a send.
  if (key.isComposing || key.keyCode === 229) return false

  // A touch screen as main pointer means a phone or tablet, whatever its width.
  if (typeof window !== 'undefined' && window.matchMedia?.('(pointer: coarse)').matches) return false

  return true
}
